import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
	providedIn: 'root',
})
export class CookiesService {
	constructor(private readonly _cookieService: CookieService) {}

	setItem(key: string, value: string): void {
		const currentDomainByPC = window.location.hostname;
		let domain = '';
		if (currentDomainByPC.includes('localhost')) {
			domain = 'localhost';
		} else if (currentDomainByPC.includes('sumax.pe')) {
			domain = 'sumax.pe';
		} else {
			domain = '.sintad.net.pe';
		}
		this._cookieService.set(key, value, undefined, '/', domain, true);
	}

	getItem(key: string): string {
		return this._cookieService.get(key);
	}

	removeItem(key: string): void {
		const currentDomainByPC = window.location.hostname;
		let domain = '';
		if (currentDomainByPC.includes('localhost')) {
			domain = 'localhost';
		} else if (currentDomainByPC.includes('sumax.pe')) {
			domain = 'sumax.pe';
		} else {
			domain = '.sintad.net.pe';
		}

		this._cookieService.delete(key, '/', domain, true);
	}

	checkItem(key: string): boolean {
		return this._cookieService.check(key);
	}
}
